import { isDefined } from "@clipboard-health/util-ts";

import { Button } from "../../components/Button";
import { PageFooterWrapper } from "../../components/PageFooterWrapper";

interface RoleDetailsFooterProps {
  onRemoveRole: () => void;
  qualificationLabel: string;
  onAddLicense?: () => void;
}

export function RoleDetailsFooter(props: RoleDetailsFooterProps) {
  const { onAddLicense, onRemoveRole, qualificationLabel } = props;

  return (
    <PageFooterWrapper withShadow>
      {isDefined(onAddLicense) && (
        <Button
          fullWidth
          size="large"
          variant="contained"
          sx={{ marginBottom: 4 }}
          onClick={onAddLicense}
        >
          Upload new license
        </Button>
      )}

      <Button fullWidth size="large" variant="outlined" onClick={onRemoveRole}>
        Remove {qualificationLabel} role
      </Button>
    </PageFooterWrapper>
  );
}
